// Shared visual tokens for the Account settings screens. Adapted to the app's
// existing look (Fraunces headings / Outfit body, warm off-white background)
// rather than the handoff's Newsreader/Hanken Grotesk — same structure, native
// feel. The green accent reads as "administrator / editable".

export const T = {
  serif: "'Fraunces',Georgia,serif",
  body: "'Outfit',sans-serif",

  pageBg: '#f6f5f1',
  cardBg: '#ffffff',
  cardBorder: '#e6e1d5',
  divider: '#efece4',
  panelBg: '#faf8f2',

  textHeading: '#1f2a2e',
  textPrimary: '#2a2e26',
  textMuted: '#6d726a',
  textFaint: '#9a9e94',

  green: '#1c7d45',
  greenPillBg: '#e7f4ec',
  greenDot: '#2ea55f',

  greyPillBg: '#eef1ea',
  greyPillText: '#6b706a',
  greyDot: '#a4a89e',

  amberText: '#a06a1a',
  amberBg: '#fbf1dc',
  amberDot: '#e79a45',

  link: '#2f6ca3',
  error: '#c0463d',
};

// Risk-tier palette for the "Light mode" dot when color-coded (matches handoff).
export const RISK_DOT = {
  BASELINE: '#3fbf72',
  ELEVATED: '#eccb4f',
  ADVISORY: '#e79a45',
  WARNING: '#e2544a',
};
export const NAV_DOT = '#f2e4b8'; // pale amber for navigation mode

export const card = {
  background: T.cardBg,
  border: `1px solid ${T.cardBorder}`,
  borderRadius: 16,
  padding: '26px 28px',
};

export const definitionRow = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: 16,
  padding: '15px 0',
  borderTop: `1px solid ${T.divider}`,
};
